/* eslint-disable consistent-return */
import * as ActionCreators from './actionCreators';
import * as InvitesActions from './invitesActions';

const emailPattern = /^(([\w '-.&]*<[^,;\s@<>]+@[^\s@<>]+\.[^\s@,;<>]+>(\s*[,;]\s*|$))|([^,;\s@<>]+@[^\s@<>]+\.[^\s@,;<>]+(\s*[,;]\s*|$)))+$/i;

export function filterAlreadySelectedUsers(selectedUsers, returnedUsers) {
  const selectedIds = [];
  const finalUsers = [];

  for (let i = 0; i < selectedUsers.length; i += 1) {
    selectedIds.push(selectedUsers[i].employeeId);
  }
  for (let i = 0; i < returnedUsers.length; i += 1) {
    if (selectedIds.indexOf(returnedUsers[i].employeeId) === -1) {
      finalUsers.push(returnedUsers[i]);
    }
  }
  return finalUsers;
}

export function userResultClick(
  fullName,
  emailAddress,
  department,
  employeeId,
  event,
) {
  event.preventDefault();
  const searchBox = document.querySelector('textarea[name="coworkers"]');
  searchBox.focus();
  searchBox.select();

  return dispatch => {
    dispatch(ActionCreators.updateAutoCompleteTextAreaValue(''));
    dispatch(ActionCreators.throwError(''));
    dispatch(ActionCreators.changeUserSearchInView(false));
    dispatch(
      ActionCreators.addAutoCompleteSelectedUser({
        fullName,
        emailAddress,
        department,
        employeeId,
      }),
    );
    dispatch(ActionCreators.updateUserSearchResults([]));
  };
}

export function autoCompleteSubmit(postUrl, useV3) {
  return (dispatch, getState) => {
    const emailPayload = { coworkers: {} };
    const { selectedUsers } = getState();
    let sentEmailArray = [];

    if (useV3) {
      selectedUsers.forEach(user => {
        emailPayload.coworkers[user.emailAddress] = user.employeeId;
        sentEmailArray.push(user.emailAddress);
      });
    } else {
      sentEmailArray = selectedUsers.map(user => user.emailAddress);
      emailPayload.coworkers = sentEmailArray;
    }
    dispatch(ActionCreators.removeAllSelectedUsers());
    dispatch(
      InvitesActions.postEmailInvitations(
        emailPayload,
        sentEmailArray,
        postUrl,
      ),
    );
  };
}

export function userSearch(url, event) {
  return (dispatch, getState) => {
    let selectedUser = {};
    const searchText = getState().autoCompleteTextAreaValue;

    if (searchText && searchText.length > 1) {
      switch (event.keyCode) {
        case 37: // Left arrow
        case 38: // Up arrow
        case 39: // Right arrow
        case 40: // Down arrow
        case 16: // Shift
        case 17: // Ctrl
        case 18: // Alt
        case 9: // Tab
          break;

        case 8: // Delete
          dispatch(ActionCreators.changeHoverSelectedUser(0));
          dispatch(ActionCreators.throwError(''));
          break;

        case 27: // Escape
          dispatch(ActionCreators.changeUserSearchInView(false));
          dispatch(ActionCreators.updateUserSearchResults([]));
          break;

        case 13: // Enter
        case 186: // Semicolon
        case 188: // Comma
          event.preventDefault();
          if (!emailPattern.test(searchText)) {
            return dispatch(ActionCreators.throwError('invalid-format'));
          }
          selectedUser = {
            fullName: searchText,
            emailAddress: searchText,
            department: '(No department specified)',
            employeeId: null,
            key: new Date().getTime().toString(),
          };

          dispatch(ActionCreators.addAutoCompleteSelectedUser(selectedUser));
          dispatch(ActionCreators.changeUserSearchInView(false));
          dispatch(ActionCreators.updateUserSearchResults([]));
          dispatch(ActionCreators.updateAutoCompleteTextAreaValue(''));
          break;

        default:
          if (getState().userSearchStatus === 'error') {
            dispatch(ActionCreators.updateUserSearchResultsHeight('0px'));
          }
          dispatch(ActionCreators.throwError(''));
          break;
      }
    } else {
      return dispatch(ActionCreators.changeUserSearchInView(false));
    }
  };
}

export function checkForAndAddUser() {
  return (dispatch, getState) => {
    if (getState().userSearchResults.length > 0) {
      return () => {};
    }

    const textAreaValue = getState().autoCompleteTextAreaValue;
    const sentEmailArray = textAreaValue.split(/[\s\,\;]/g).filter(el => el); //eslint-disable-line

    if (sentEmailArray.length === 0) {
      return () => {};
    }
    const emailsAreValid = sentEmailArray.every(email =>
      emailPattern.test(email),
    );
    if (!emailsAreValid) {
      dispatch(ActionCreators.changeUserSearchInView(false));
      dispatch(ActionCreators.updateUserSearchResults([]));
      return dispatch(ActionCreators.throwError('invalid-format'));
    }

    for (let i = 0; i < sentEmailArray.length; i += 1) {
      const selectedUser = {
        fullName: sentEmailArray[i],
        emailAddress: sentEmailArray[i],
        department: '(No department specified)',
        employeeId: null,
        key: new Date().getTime().toString() + sentEmailArray[i],
      };
      dispatch(ActionCreators.addAutoCompleteSelectedUser(selectedUser));
    }
    dispatch(ActionCreators.changeUserSearchInView(false));
    dispatch(ActionCreators.updateUserSearchResults([]));
    return dispatch(ActionCreators.updateAutoCompleteTextAreaValue(''));
  };
}
